import { render, staticRenderFns } from "./PassiveStockDashboardVS.vue?vue&type=template&id=bf876124&scoped=true"
import script from "./PassiveStockDashboardVS.vue?vue&type=script&lang=js"
export * from "./PassiveStockDashboardVS.vue?vue&type=script&lang=js"
import style0 from "./PassiveStockDashboardVS.vue?vue&type=style&index=0&id=bf876124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf876124",
  null
  
)

export default component.exports